import { NextRouter, useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { useEffect } from 'react';

export const removeSearchParams = (
  query: ParsedUrlQuery,
  params: string[],
  replace: NextRouter['replace'],
  shallow = true,
): void => {
  const newQuery = { ...query };
  params.forEach((param) => {
    if (Object.hasOwn(query, param)) {
      delete newQuery[param];
    }
  });
  replace({ query: newQuery }, undefined, { shallow });
};

export const removeSearchParam = (
  query: ParsedUrlQuery,
  param: string,
  replace: NextRouter['replace'],
  shallow = true,
): void => {
  if (Object.hasOwn(query, param)) {
    const newQuery = {
      ...query,
    };
    delete newQuery[param];
    replace({ query: newQuery }, undefined, { shallow });
  }
};

/**
 * Removes the specified query string param if it exists.
 * Replaces the current history state.
 *
 * @param param The query string param to remove
 */
const useRemoveSearchParam = (param: string, shallow = true): void => {
  const { replace, query } = useRouter();
  useEffect(() => {
    removeSearchParam(query, param, replace, shallow);
  }, [param, replace, query, shallow]);
};

export default useRemoveSearchParam;
